import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#0051a2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        plm: '#003366'
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: 'md',
    values: { expand: 'mdi-menu-down' },
  },
});
